module.exports = __webpack_public_path__ + "156205e123077195a2adfde5967d393a.svg";